import { CycleType, DurationUnit } from '@wix/ambassador-premium-cart-v1-cart/types';
import { IntervalUnit } from '@wix/ambassador-premium-store-v1-dynamic-offering-service-entity/types';
export const cycleMappers = {
  CartCycleToDynamicCycle: cartCycle => {
    const DurationToInterval = {
      [DurationUnit.DAY]: IntervalUnit.DAY,
      [DurationUnit.WEEK]: IntervalUnit.WEEK,
      [DurationUnit.MONTH]: IntervalUnit.MONTH,
      [DurationUnit.YEAR]: IntervalUnit.YEAR,
      [DurationUnit.UNKNOWN_UNIT]: IntervalUnit.UNKNOWN
    };
    let oneTime;
    let interval;
    if (cartCycle.cycleType === CycleType.ONE_TIME) {
      oneTime = {};
    } else if (cartCycle.cycleType === CycleType.RECURRING) {
      const newDuration = cartCycle.cycleDuration;
      interval = {
        unit: newDuration != null && newDuration.unit ? DurationToInterval[newDuration.unit] : IntervalUnit.UNKNOWN,
        count: newDuration == null ? void 0 : newDuration.count
      };
    } else {
      throw Error(`cycle type not exists in cycle`);
    }
    return {
      oneTime,
      interval
    };
  },
  DynamicCycleToCartCycle: dynamicCycle => {
    const IntervalToDuration = {
      [IntervalUnit.DAY]: DurationUnit.DAY,
      [IntervalUnit.WEEK]: DurationUnit.WEEK,
      [IntervalUnit.MONTH]: DurationUnit.MONTH,
      [IntervalUnit.YEAR]: DurationUnit.YEAR,
      [IntervalUnit.UNKNOWN]: DurationUnit.UNKNOWN_UNIT
    };
    let cycleType;
    let cycleDuration;
    if (dynamicCycle.oneTime) {
      cycleType = CycleType.ONE_TIME;
    } else if (dynamicCycle.interval) {
      cycleType = CycleType.RECURRING;
      const dynamicInterval = dynamicCycle.interval;
      cycleDuration = {
        unit: dynamicInterval.unit ? IntervalToDuration[dynamicInterval.unit] : DurationUnit.UNKNOWN_UNIT,
        count: dynamicInterval.count
      };
    } else {
      cycleType = CycleType.UNKNOWN_TYPE;
    }
    return {
      cycleType,
      cycleDuration
    };
  },
  CartCycleToTranslationCycle: cartCycle => {
    var _cartCycle$cycleDurat, _cartCycle$cycleDurat2;
    const count = cartCycle == null || (_cartCycle$cycleDurat = cartCycle.cycleDuration) == null ? void 0 : _cartCycle$cycleDurat.count;
    const unit = cartCycle == null || (_cartCycle$cycleDurat2 = cartCycle.cycleDuration) == null || (_cartCycle$cycleDurat2 = _cartCycle$cycleDurat2.unit) == null ? void 0 : _cartCycle$cycleDurat2.toLowerCase();
    return `${count}${unit}`;
  }
};
//# sourceMappingURL=cycle.mappers.js.map